import Cookies from 'js-cookie'

const authToken = {
  // jumpAuthPage 跳转到登录页面； getNewToken 自动获取新的token
  tokenTimeoutMethod: 'jumpAuthPage',

  // cookie中记录登录状态的key
  loginKey: 'isLogin',
  // Token是否超时
  hasToken: function () {
    return Cookies.get('token')
  },

  // 当前是否登录
  isLogin: function () {
    return Cookies.get(this.loginKey)
  },

  // 设置token
  setToken: function (token) {
    // TODO: 设置token, 并设置有效期
    let maxAge = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
    Cookies.set('token', token, {
      expires: maxAge
    })
  },

  // 移出token
  removeToken: function () {
    Cookies.remove('token')
  },

  // 设置登录状态
  setLoginStatus: function () {
    let maxAge = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
    Cookies.set(this.loginKey, 'true', {
      expires: maxAge
    })
  },

  // 清除登录状态
  removeLoginStatus: function () {
    Cookies.remove(this.loginKey)
  }
}

export default authToken



// WEBPACK FOOTER //
// ./src/utils/auth.js